import { HubSubscription } from "@axl/accel-framework/hub-client";

export default class GamificationBalanceSubscription extends HubSubscription<number> {
    method = `GamificationBalance`;
}